import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../../scrollbar.css';
import { useStateValue } from '../../ContextApi/StateProvider';

function SideMenu() {
  const history = useHistory();
  const location = useLocation();
  const [setting, setSetting] = useState(false);
  const [{ user }, dispatch] = useStateValue();

  const getNameInitials = (name) => {
    if (!name) return '';
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  };
  const [showSideMenu, setSideMenu] = useState(false);

  return (
    <div className=" sideMenu sm:w-0 md:w-sidebar flex flex-col h-screen ipad_resp">
      <div
        className="fixed block sm:hidden z-60 p-2 bg-white w-full h-10 border"
        onClick={() => setSideMenu((prev) => !prev)}
      >
        <img src="assets/img/sideMenu.png" className="w-6 h-6" />
      </div>
      {showSideMenu ? (
        <div
          className="fixed block sm:hidden z-60 p-2 bg-white w-full h-10 border cancel_side"
          onClick={() => setSideMenu((prev) => !prev)}
        >
          <img src="assets/img/cancel.png" />
        </div>
      ) : null}
      {/* <div
        className="fixed block sm:hidden z-60 p-2 bg-white w-full h-10 border cancel_side"
        onClick={() => setSideMenu((prev) => !prev)}
      >
        <img src="assets/img/cancel.png" />
      </div> */}

      <div
        className={`fixed sideMenu ${
          showSideMenu ? 'block' : 'hidden'
        } md:block lg:flex flex-col h-full z-50 ipad_width`}
        style={{ width: showSideMenu ? '50%' : '14%' }}
      >
        <div
          className="flex mb-5"
          style={{ border: '1px solid #EFEFEF' }}
          // onClick={() => history.push('/organization')}
        >
          <img src="assets/img/Logo_App.svg" alt="" className="max-w-full my-4 mx-auto imgSize" />
          {/* <img src="assets/img/icon.svg" alt="" className="max-w-full my-4 ml-4 imgSize" />
        <img src="assets/img/icon1.svg" alt="" className="max-w-full w-3/5" style={{ margin: 'auto 6px' }} /> */}
        </div>

        <div className="w-full">
          <div
            className={`${
              (location.pathname === '/dashboard' || location.pathname === '/') && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
            onClick={() => {
              setSetting(false);
              history.push('/dashboard');
            }}
          >
            {location.pathname === '/dashboard' || location.pathname === '/' ? (
              <div className="bg-btnBg  flex w-full h-10 m-auto items-center relative rounded-l-md">
                <img src="assets/img/Dashboard_White.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">Dashboard</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/DashbordIcon.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">Dashboard</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/warehouses' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-3.5'} cursor-pointer`}
            onClick={() => {
              setSetting(false);
              if (localStorage.getItem('warehouseORzone') === 'warehouses') history.push('/warehouses');
              else history.push('/zones');
            }}
          >
            {location.pathname === '/warehouses' || location.pathname === '/zones' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md width_zone">
                <img src="assets/img/Zones_Active.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">
                  {location.pathname === '/warehouses' ? 'Warehouses' : 'Zones'}
                </p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/Zones_Inactive.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">
                  {localStorage.getItem('warehouseORzone') === 'warehouses' ? 'Warehouses' : 'Zones'}
                </p>
              </div>
            )}
          </div>
          <div
            className={`${
              location.pathname === '/projects' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
            onClick={() => {
              setSetting(false);
              history.push('/projects');
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/projects' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md">
                <img src="assets/img/Project_White.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">Projects</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/ProjectIcon.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">Projects</p>
              </div>
            )}
          </div>

          <div
            className={`${location.pathname === '/users' && 'text-activeIcon'} block md:flex  items-center h-1/7 ml-4 ${
              setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'
            } cursor-pointer`}
            onClick={() => {
              setSetting(false);
              history.push('/users');
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/users' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md">
                <img src="assets/img/User_White.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">Users</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/UserIcon.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">Users</p>
              </div>
            )}
          </div>
          <div
            className={`${
              location.pathname === '/printers' && 'text-activeIcon'
            } block md:flex  items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
            onClick={() => {
              setSetting(false);
              history.push('/printers');
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/printers' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md">
                <img src="assets/img/printer.png" alt="" className="h-5 mx-2" />
                <p className="text-white font-medium text-sm  md:block">Printers</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/printer.png" alt="" className="h-5 mx-2" />
                <p className="text-role font-medium text-sm  md:block">Printers</p>
              </div>
            )}
          </div>
          <div
            className={`${
              location.pathname === '/devices' && 'text-activeIcon'
            } block md:flex h-1/7 items-center ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
            onClick={() => {
              setSetting(false);
              history.push('/devices');
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/devices' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md">
                <img src="assets/img/Devices_White.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">Devices</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/DevicesIcon.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">Devices</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/organization' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
            onClick={() => history.push('/organization')}
          >
            {location.pathname === '/organization' || setting ? (
              <div
                className="bg-btnBg flex w-full h-10 m-auto items-center relative rounded-l-md"
                onClick={() => setSetting((prev) => !prev)}
              >
                <img src="assets/img/SettingsWhite.svg" alt="" className="h-4 mx-3" />
                <p className="text-white font-medium text-sm  md:block">Settings</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center" onClick={() => setSetting((prev) => !prev)}>
                <img src="assets/img/SettingsGrey.svg" alt="" className="h-4 mx-3" />
                <p className="text-role font-medium text-sm  md:block">Settings</p>
              </div>
            )}
          </div>
          {setting && (
            <div className="mx-4">
              <div
                className={`${
                  location.pathname === '/webhooks' && 'text-activeIcon'
                } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
                onClick={() => history.push('/webhooks')}
              >
                {location.pathname === '/webhooks' ? (
                  <div className="bg-subMenuSelected flex w-full h-10 m-auto items-center relative rounded-l-md">
                    <img src="assets/img/Webhook_White.svg" alt="" className="h-4 mx-3" />
                    <p className="text-white font-medium text-sm  md:block">Webhooks</p>
                    <img
                      src="assets/img/leftArrow.svg"
                      className="absolute right-4"
                      style={{ height: '10px' }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="flex w-full h-10 m-auto items-center">
                    <img src="assets/img/WebhookIcon.svg" alt="" className="h-4 mx-3" />
                    <p className="text-role font-medium text-sm  md:block">Webhooks</p>
                  </div>
                )}
              </div>
              <div
                className={`${
                  location.pathname === '/rules' && 'text-activeIcon'
                } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
                onClick={() => history.push('/rules')}
              >
                {location.pathname === '/rules' ? (
                  <div className="bg-subMenuSelected flex w-full h-10 m-auto items-center relative rounded-l-md">
                    <img src="assets/img/Rules_White.svg" alt="" className="h-4 mx-3" />
                    <p className="text-white font-medium text-sm  md:block">Rules</p>
                    <img
                      src="assets/img/leftArrow.svg"
                      className="absolute right-4"
                      style={{ height: '10px' }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="flex w-full h-10 m-auto items-center">
                    <img src="assets/img/Rules_Grey.svg" alt="" className="h-4 mx-3" />
                    <p className="text-role font-medium text-sm  md:block">Rules</p>
                  </div>
                )}
              </div>

              <div
                className={`${
                  location.pathname === '/geofence' && 'text-activeIcon'
                } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
                onClick={() => history.push('/geofence')}
              >
                {location.pathname === '/geofence' ? (
                  <div className="bg-subMenuSelected flex w-full h-10 m-auto items-center relative rounded-l-md">
                    <img src="assets/img/Audit Trail_White.svg" alt="" className="h-4 mx-3" />
                    <p className="text-white font-medium text-sm  md:block">GeoFence</p>
                    <img
                      src="assets/img/leftArrow.svg"
                      className="absolute right-4"
                      style={{ height: '10px' }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="flex w-full h-10 m-auto items-center">
                    <img src="assets/img/Audit Trail_Grey.svg" alt="" className="h-4 mx-3" />
                    <p className="text-role font-medium text-sm  md:block">GeoFence</p>
                  </div>
                )}
              </div>

              <div
                className={`${
                  location.pathname === '/audit-trail' && 'text-activeIcon'
                } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
                onClick={() => history.push('/audit-trail')}
              >
                {location.pathname === '/audit-trail' ? (
                  <div className="bg-subMenuSelected flex w-full h-10 m-auto items-center relative rounded-l-md">
                    <img src="assets/img/Audit Trail_White.svg" alt="" className="h-4 mx-3" />
                    <p className="text-white font-medium text-sm  md:block">Audit Trail</p>
                    <img
                      src="assets/img/leftArrow.svg"
                      className="absolute right-4"
                      style={{ height: '10px' }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="flex w-full h-10 m-auto items-center">
                    <img src="assets/img/Audit Trail_Grey.svg" alt="" className="h-4 mx-3" />
                    <p className="text-role font-medium text-sm  md:block">Audit Trail</p>
                  </div>
                )}
              </div>

              {/* <div
                className={`${
                  location.pathname === '/floorPlan' && 'text-activeIcon'
                } block md:flex items-center h-1/7 ml-4 ${setting ? 'mb-0 xl:mb-1' : 'mb-1 xl:mb-5'} cursor-pointer`}
                onClick={() => history.push('/floorPlan')}
              >
                {location.pathname === '/floorPlan' ? (
                  <div className="bg-subMenuSelected flex w-full h-10 m-auto items-center relative rounded-l-md">
                    <img src="assets/img/Audit Trail_White.svg" alt="" className="h-4 mx-3" />
                    <p className="text-white font-medium text-sm  md:block">Floor Plan</p>
                    <img
                      src="assets/img/leftArrow.svg"
                      className="absolute right-4"
                      style={{ height: '10px' }}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="flex w-full h-10 m-auto items-center">
                    <img src="assets/img/Audit Trail_Grey.svg" alt="" className="h-4 mx-3" />
                    <p className="text-role font-medium text-sm  md:block">Floor Plan</p>
                  </div>
                )}
              </div> */}
            </div>
          )}
        </div>

        <div className="logout rounded-md">
          <div
            className={`mr-2 h-6 md:h-12 w-6 md:w-12 flex justify-center items-center rounded-full ${
              !user?.avatar && 'bg-primary'
            } userInfo cursor-pointer`}
            onClick={() => history.push('/account')}
          >
            {user?.avatar ? (
              <img src={`${user?.avatar}?${global.Date.now()}`} className="h-full w-full rounded-full" />
            ) : (
              <span className="text-base">{getNameInitials(user?.userName)}</span>
            )}
          </div>
          <div className="flex flex-col items-center w-full">
            <span
              className="text-sm font-bold hidden md:block cursor-pointer overflow-ellipsis overflow-hidden whitespace-nowrap w-11/12"
              onClick={() => history.push('/account')}
            >
              {user?.userName}
            </span>
            <button
              type="submit"
              className="logoutBtn px-0 md:px-6 py-0 md:py-1.5"
              onClick={() => {
                sessionStorage.clear();
                history.replace('/');
                dispatch({
                  type: 'USER_DATA',
                  user: null,
                });
              }}
            >
              Logout
            </button>
          </div>
        </div>
        {/* <div className="relative bottom-0 text-center text-xs">
        <img src="assets/img/icon1.svg" className="w-28 mx-auto ${setting ? 'mb-0 xl:mb-1': 'mb-1 xl:mb-5'}" alt="" />
        <span className="mx-auto text-role font-medium">© 2021. All Rights Reserved</span>
      </div> */}
      </div>
    </div>
  );
}

export default SideMenu;
